import { render, staticRenderFns } from "./SidebarContent.vue?vue&type=template&id=1ed32fb8&scoped=true&"
import script from "./SidebarContent.vue?vue&type=script&lang=ts&"
export * from "./SidebarContent.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarContent.vue?vue&type=style&index=0&id=1ed32fb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed32fb8",
  null
  
)

export default component.exports